import { Text, Stack, StackProps } from '@chakra-ui/react';
import { SearchIconLarge } from 'assets/common/SearchIconLarge';
import { ReactElement } from 'react';

type NoContentProps = {
  minHeight?: StackProps['minH'];
  children: React.ReactNode;
};

export const NoContentTextWrapper = ({ minHeight, children }: NoContentProps): ReactElement => {
  const calculatedMinHeight = minHeight || '70vh';
  return (
    <Stack
      maxW="100%"
      height="100%"
      minH={calculatedMinHeight}
      alignItems="center"
      textAlign="center"
      justifyContent="center"
      gap="14"
      px="4"
    >
      <SearchIconLarge boxSize="130px" ml="70px" />
      <Text textStyle="h4.regular" color="text.quaternary">
        {children}
      </Text>
    </Stack>
  );
};
